module.exports = __webpack_public_path__ + "media/ding_extended_10s.9a04d502.mp3";